import React from 'react';

interface PaymentStatusBadgeProps {
  status: string;
}

const PaymentStatusBadge: React.FC<PaymentStatusBadgeProps> = ({ status }) => {
  const getStatusConfig = (status: string) => {
    switch (status?.toUpperCase()) {
      case 'PAID':
      case 'COMPLETED':
        return { label: 'Paid', className: 'bg-green-500', textColor: 'text-white' };
      case 'PENDING':
        return { label: 'Pending', className: 'bg-yellow-100', textColor: 'text-amber-800' };
      case 'FAILED':
        return { label: 'Failed', className: 'bg-red-500', textColor: 'text-white' };
      case 'REFUNDED':
        return { label: 'Refunded', className: 'bg-purple-500', textColor: 'text-white' };
      case 'SENT':
        return { label: 'Sent', className: 'bg-blue-500', textColor: 'text-white' };
      case 'DRAFT':
        return { label: 'Draft', className: 'bg-gray-500', textColor: 'text-white' };
      default:
        return { label: status || 'Unknown', className: 'bg-gray-500', textColor: 'text-white' };
    }
  };

  const config = getStatusConfig(status);

  return (
    <span
      className={`px-2 py-1 rounded-full text-xs font-medium ${config.className} ${config.textColor}`}
    >
      {config.label}
    </span>
  );
};

export default PaymentStatusBadge;

